<template>
  <div class="order-content">
    <div class="order-card ">
      <div class="order-header">
        <div class="order-search-box">
          <a-input-group compact>
            <a-select v-model:value="orderSearch"
                      :options="orderSearchValue"
                      class="order-search-select">
            </a-select>
            <a-input v-model:value="inputValue"
                     :placeholder="$t('orderManagement.OrderManagement.enterInfo')"
                     class="order-search-input"
                     @press-enter="submit" />
          </a-input-group>
        </div>
        <div class="btn-box">
          <a-button class="search-button"
                    @click="submit">
            <search-outlined class="icon-size" />
            <span>{{ $t('orderManagement.OrderManagement.search') }}</span>
          </a-button>
          <a-button class="order-button"
                    @click="clearValue(true)">
            <redo-outlined class="icon-size"
                           :rotate="270" />{{ $t('orderManagement.OrderManagement.resetAll') }}
          </a-button>
          <!-- <a-button class="order-button">
            <download-outlined class="icon-size" />导入订单
          </a-button> -->
          <a-button class="order-button btn-width"
                    @click="clearValue(false)">
            <clear-outlined class="icon-size" />{{ $t('orderManagement.OrderManagement.clearFilter') }}
          </a-button>
        </div>
      </div>
      <div class="order-search">
        <a-form :layout="'inline'"
                :model="searchForm">
          <a-form-item :label="$t('orderManagement.OrderManagement.orderSource')">
            <a-select v-model:value="searchForm.type"
                      :options="typeList">
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('orderManagement.OrderManagement.orderStatus')">
            <a-select v-model:value="searchForm.status">
              <a-select-option value="">{{ $t('orderManagement.OrderManagement.all') }}</a-select-option>
              <a-select-option v-for="statusItem in statusType"
                               :key="statusItem.value"
                               :value="statusItem.value">{{ statusItem.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('orderManagement.OrderManagement.orderTime')">
            <a-select v-model:value="orderTime"
                      lab
                      :options="timeType"
                      @select="radioChangeTime('orderTime')">
            </a-select>
            <a-range-picker ref="rangePickerRef"
                            v-model:value="value1"
                            class="rangePicker"
                            clearable
                            @change="onChangeDate" />
          </a-form-item>
          <a-form-item :label="$t('orderManagement.OrderManagement.deliveryTime')">
            <a-select v-model:value="deliverTime"
                      :options="timeType"
                      @select="radioChangeTime('deliverTime')">
            </a-select>
            <a-range-picker ref="rangePickerRef"
                            v-model:value="value2"
                            class="rangePicker"
                            clearable
                            @change="onChangeDateDeliver" />
          </a-form-item>
          <a-form-item :label="$t('orderManagement.OrderManagement.importTime')">
            <a-select v-model:value="importTime"
                      :options="timeType"
                      @select="radioChangeTime('importTime')">
            </a-select>
            <a-range-picker ref="rangePickerRef"
                            v-model:value="value3"
                            class="rangePicker"
                            clearable
                            @change="onChangeDateImport" />
          </a-form-item>
        </a-form>
      </div>
    </div>
    <a-divider />
    <div class="order-middle">
      {{ $t('orderManagement.OrderManagement.searchTotal') }}<span class="totle-title">{{ total
      }}</span>{{ $t('orderManagement.OrderManagement.results') }}
    </div>
    <div class="order-card order-footer">
      <div ref="hiddenContainer"
           class="hidden"></div>
      <a-scroll-table class="scrollTable"
                      :columns="ORDER_COLUMNS"
                      :loading="flag"
                      :data-source="orderData"
                      :pagination="false"
                      row-key="id">
        <template #bodyCell="{ column, text: items, record }">
          <template v-if="column.dataIndex === 'items'">
            <div v-for="item in items"
                 :key="item.id">
              <a-popover placement="topLeft">
                <div class="flex-box">
                  <div>
                    <div v-if="item.is_custom"
                         class="viewer">
                      <CustomizedImagePreview :customized-data="mergeCustomAreaData(item)" />
                    </div>
                    <img v-else
                         :src="toUrl(item.image)"
                         class="viewer" />
                  </div>
                  <div class="item-flex">
                    <div>{{ item.spu_name }}</div>
                    <div class="item-attr">
                      <span v-for="(attr, index) in convertAttrs(item.sku_attrs)"
                            :key="index">
                        {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="item-quality">
                    x{{ item.quality }}
                  </div>
                </div>
                <template #content>
                  <price-breakdown v-if="item.price_detail"
                                   :custom-price-detail="item.price_detail"
                                   :is-custom="item.is_custom"
                                   :quantity="item.quality"
                                   :is-order="true"></price-breakdown>
                </template>
              </a-popover>
            </div>
          </template>
          <template v-if="column.dataIndex === 'pay_amount'">
            <a-popover placement="top"
                       tigger="click">
              <div v-if="record.adjustPrice">{{ record.adjustPrice.pay_amount }}</div>
              <div v-else>{{ record.pay_amount }}</div>
              <template #content>
                <div v-if="record.sale">
                  <FlashbaseAdjustDetail v-if="record.adjustPrice || record.sale"
                                         :sale-data="record.sale"
                                         :adjust-data="record.adjustPrice"
                                         :is-order="true"
                                         :is-adjust="record.adjustPrice"
                                         :is-sale="record.sale"></FlashbaseAdjustDetail>
                </div>
                <div v-else>
                  <a-row>
                    <a-col :span="12"
                           class="total-pee">{{ $t('orderManagement.OrderManagement.totalPee') }}</a-col>
                    <a-col :span="12"
                           class="price-color text-align">￥{{ record.pay_amount }}</a-col>
                    <a-divider class="divider-line" />
                    <a-col :span="12">{{ $t('orderManagement.OrderManagement.payAmount') }}</a-col>
                    <a-col :span="12"
                           class="price-size text-align">￥{{ new
                            BigNumber(record.pay_amount).minus(record.express_fee).toNumber()
                          }}</a-col>
                    <a-col :span="12">{{ $t('orderManagement.OrderManagement.expressFee') }}</a-col>
                    <a-col :span="12"
                           class="price-size text-align">￥{{ record.express_fee }}</a-col>
                  </a-row>
                </div>
              </template>
            </a-popover>

          </template>
          <template v-if="column.dataIndex === 'receive_address'">
            <div class="receive-address">
              <div
                   v-if="record.receiver && record.receiver_phone && record.receiver != 'null' && record.receiver_phone != 'null' && record.receiver != 'undefined' && record.receiver_phone != 'undefined'">
                <div>
                  <span>{{ record.receiver }}</span>
                  <span class="receiver-margin">{{ record.receiver_phone }}</span>
                </div>
                <div>{{ record.receive_address }}
                </div>
              </div>
              <div v-else>{{ $t('orderManagement.OrderManagement.selfPickup') }}</div>
              <p class="receive-address-deliver"
                 @click.stop="openAddressModal(record)">{{ $t('orderManagement.OrderManagement.more') }}</p>
            </div>
          </template>
          <!-- 快递详情 -->
          <template v-if="column.dataIndex === 'express_number'">
            <div v-if="record.express_company_id == 17">
              <div class="express-self-pickup">{{ $t('orderManagement.OrderManagement.address') }}</div>
              <div class="express-self-pickup">{{ $t('orderManagement.OrderManagement.pickCode') }}：{{ record.number }}
              </div>
            </div>
            <a v-else
               @click="expressClick(record)">{{ record.express_number }}</a>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <div v-for="item in statusType"
                 :key="item.value"><span v-if="item.value == record.status">{{ item.label }}</span></div>
          </template>
          <template v-if="column.dataIndex === 'operation'">
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.detail') }}</span>
              </template>
              <file-search-outlined class="operation-icon"
                                    @click="goToDetail(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.pay') }}</span>
              </template>
              <wallet-outlined v-if="record.status == 1"
                               class="operation-icon"
                               @click="payClick(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.cancel') }}</span>
              </template>
              <close-circle-outlined v-if="record.status == 1"
                                     class="operation-icon"
                                     @click="cancelPayment(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.refund') }}</span>
              </template>
              <transaction-outlined v-if="record.status == 2"
                                    class="operation-icon"
                                    @click="refundApply(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.cancelRefund') }}</span>
              </template>
              <MoneyCollectOutlined v-if="record.status == 7"
                                    class="operation-icon"
                                    @click="cancelRefund(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.delivery') }}</span>
              </template>
              <inbox-outlined v-if="record.status == 5"
                              class="operation-icon"
                              @click="openAddressModal(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ record.refunds.length > 0 ? $t('orderManagement.OrderManagement.checkRefund') :
                  $t('orderManagement.OrderManagement.applyRefund') }}</span>
              </template>
              <customer-service-outlined v-if="![1, 2, 7, 8].includes(record.status)"
                                         class="operation-icon"
                                         @click="afterSaleClick(record)" />
            </a-tooltip>
            <a-tooltip placement="bottom"
                       :color="'#111'">
              <template #title>
                <span>{{ $t('orderManagement.OrderManagement.comment') }}</span>
              </template>
              <comment-outlined v-if="record.status == 6 && isComment(record.items)"
                                class="operation-icon"
                                @click="goToComment(record)" />
            </a-tooltip>
          </template>
        </template>
      </a-scroll-table>
      <a-row class="page-box">
        <div>
          <!-- <a-pagination v-model:pageSize="searchForm.limit"
                        v-model:current="current"
                        show-size-changer
                        :total="total"
                        show-quick-jumper
                        @change="changePage" /> -->
          <APagination v-model:current="current"
                       v-model:pageSize="searchForm.limit"
                       :show-size-changer="true"
                       :total="total"
                       @change="changePage" />
        </div>
      </a-row>
    </div>
    <!-- 取消付款 -->
    <a-modal v-model:visible="visible"
             :title="title"
             @ok="onCancelOk"
             @cancel="visible = false">
      <p class="icon-size">{{ content }}</p>
    </a-modal>
    <a-modal v-model:visible="payVisible"
             :title="$t('orderManagement.OrderManagement.selectMethod')"
             @ok="onCancelPayOk"
             @cancel="payVisible = false">
      <h4>{{ $t('orderManagement.OrderManagement.paymentMethod') }}:</h4>
      <a-radio-group v-model:value="payment">
        <a-radio :value="0">{{ $t('orderManagement.OrderManagement.alipay') }}</a-radio>
        <a-radio :value="1">{{ $t('orderManagement.OrderManagement.wxpay') }}</a-radio>
        <!-- <a-radio :value="3">云闪付</a-radio>
        <a-radio :value="4">银行转账</a-radio> -->
      </a-radio-group>
    </a-modal>
    <!-- 退款申请 -->
    <a-modal v-model:visible="remarkVisible"
             :title="$t('orderManagement.OrderManagement.refundReason')"
             width="700px">
      <div>
        <p class="refund-application-content">{{ $t('orderManagement.OrderManagement.warmPrompt') }}</p>
        <a-radio-group v-model:value="remarkValue">
          <a-radio :value="$t('orderManagement.OrderManagement.deliveryTimeProblem')">{{
            $t('orderManagement.OrderManagement.deliveryTimeProblem') }}</a-radio>
          <a-radio :value="$t('orderManagement.OrderManagement.wrongGoods')">{{
            $t('orderManagement.OrderManagement.wrongGoods') }}</a-radio>
          <a-radio :value="$t('orderManagement.OrderManagement.addressError')">{{
            $t('orderManagement.OrderManagement.addressError') }}</a-radio>
          <a-radio :value="$t('orderManagement.OrderManagement.goodsError')">{{
            $t('orderManagement.OrderManagement.goodsError') }}</a-radio>
          <a-radio :value="$t('orderManagement.OrderManagement.dontWant')">{{
            $t('orderManagement.OrderManagement.dontWant') }}</a-radio>
        </a-radio-group>
      </div>
      <template #footer>
        <a-button key="back"
                  @click="closeRemarkVisible">{{ $t('orderManagement.OrderManagement.cancel') }}</a-button>
        <a-button key="submit"
                  type="primary"
                  :disabled="!remarkValue"
                  @click="onCancelOk">{{ $t('orderManagement.OrderManagement.applyForRefund') }}</a-button>
      </template>
    </a-modal>
    <!-- 微信二维码 -->
    <a-modal v-model:visible="wxVisible"
             :title="$t('orderManagement.OrderManagement.wxpay')"
             :confirm-loading="confirmLoading"
             @ok="onCancelWxpayOk"
             @cancel="onCancelWxpayOk">
      <div class="flex">
        <a-image :width="200"
                 :preview="false"
                 :src="code_img" />
      </div>
      <div class="flex">
        {{ $t('orderManagement.OrderManagement.scanCode') }}
      </div>
    </a-modal>
    <FlashbaseAfterSale :data="afterSaleContent"
                        :visible="afterVisible"
                        :is-admin="false"
                        :after-type="afterType"
                        @after-change="afterChange"></FlashbaseAfterSale>
    <express :visible="expressVisible"
             :row-data="rowData"
             :receive-address="receive_address"
             @visible-change="visibleChange"></express>
    <a-modal v-model:visible="addressVisible"
             width="80vw"
             :destroy-on-close="true"
             :title="$t('orderManagement.OrderManagement.recipientInformation')"
             @cancel="updateOrderList">
      <FlashbaseOrderAddress :order-info="currentOrderInfo"
                             :is-admin="false"
                             @express-click="expressClick"
                             @confirm-update-order="confirmUpdateOrder" />
      <template #footer>
        <a-button key="back"
                  @click="updateOrderList">{{ $t('orderManagement.OrderManagement.cancel') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { toUrl } from "@/utils"
import { message } from 'ant-design-vue'
import dayjs, { Dayjs } from 'dayjs'
import QRCode from 'qrcode'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { alipay, fetchOrder, queryAlipay, queryExpress, queryWxpay, updateOrder, wxpay, cancelOrder, refundOrder, fetchOrderStatus } from '../api/index'
import { type OrderDetails, type SearchForm, convertColor } from '../config'
import { AScrollTable, APagination, CustomizedImagePreview } from '@iota-cn/ui-components'
import PriceBreakdown from '../../custom-spus/view/components/PriceBreakdown.vue'
import express from './components/Express.vue'
import { sortBy, renderImageBaseUrl } from '../../custom-spus/utils'
import BigNumber from "bignumber.js"
import { useRouter, useRoute } from "vue-router"
import type { TableColumnsType } from 'ant-design-vue'
import { useI18n } from "vue-i18n"

const { t } = useI18n()
// import afterSale from "./components/AfterSale.vue"
const router = useRouter()
const route = useRoute()
const hiddenContainer = ref()
const wxVisible = ref<boolean>(false)
const code_img = ref('')
const addressVisible = ref<boolean>(false)
const currentOrderInfo = ref<OrderDetails>()
const isUpdateOrder = ref<boolean>(false)

onMounted(async () => {
  const fromData = sessionStorage.getItem('searchForm')
  if (route.params.from == 'detail' && fromData) {
    const data = JSON.parse(fromData)
    data.orderSearch ? orderSearch.value = data.orderSearch : ''
    data.inputValue ? inputValue.value = data.inputValue : ''
    data.orderTime ? orderTime.value = data.orderTime : ''
    data.deliverTime ? deliverTime.value = data.deliverTime : ''
    data.importTime ? importTime.value = data.importTime : ''
    data.current ? current.value = data.current : ''
    data.limit ? searchForm.limit = data.limit : ''
    data.type ? searchForm.type = data.type : ''
    data.status ? searchForm.status = data.status : ''
    data.value1 ? value1.value = [dayjs(data.value1[0]), dayjs(data.value1[1])] : ''
    data.value2 ? value2.value = [dayjs(data.value2[0]), dayjs(data.value2[1])] : ''
    data.value3 ? value3.value = [dayjs(data.value3[0]), dayjs(data.value3[1])] : ''
    await getOrderList(JSON.parse(fromData))
  } else {
    await getOrderList()
  }
  statusType.value = []
  await fetchOrderStatus().then((res) => {
    res.data.items.forEach((item: any) => {
      statusType.value.push({
        value: item.key,
        label: item.name
      })
    })
  })
  sessionStorage.clear()
})
const ORDER_COLUMNS = computed<TableColumnsType>(() => [
  {
    title: t('orderManagement.OrderManagement.goods'),
    dataIndex: 'items',
    width: 450,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.amount'),
    dataIndex: 'pay_amount',
    width: 100,
    align: 'center',
    ellipsis: true,
    customCell: () => {
      return {
        style: {
          color: "#DE4A09"
        }
      }
    },
  },
  {
    title: t('orderManagement.OrderManagement.orderNumber'),
    dataIndex: 'number',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.creationTime'),
    dataIndex: 'createdAt',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.receivingInformation'),
    dataIndex: 'receive_address',
    width: 250,
    align: 'center',
    ellipsis: true,
  },
  // {
  //   title: '快递信息',
  //   dataIndex: 'express_number',
  //   width: 250,
  //   align: 'center',
  //   ellipsis: true,
  // },
  {
    title: t('orderManagement.OrderManagement.transactionStatus'),
    dataIndex: 'status',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.remark'),
    dataIndex: 'remark',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.paymentTime'),
    dataIndex: 'pay_at',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.deliveryTime'),
    dataIndex: 'deliver_at',
    width: 200,
    align: 'center',
    ellipsis: true,
  },
  {
    title: t('orderManagement.OrderManagement.operation'),
    dataIndex: 'operation',
    fixed: 'right',
    align: 'center',
    width: 200,
  }
])
const confirmUpdateOrder = () => {
  isUpdateOrder.value = true
}

const updateOrderList = async () => {
  addressVisible.value = false
  if (isUpdateOrder.value) {
    isUpdateOrder.value = false
    await getOrderList()
  }
}

const mergeCustomAreaData = (item: any) => {
  return Object.assign(
    {},
    {
      image: renderImageBaseUrl(item),
      customArea: Object.assign({},
        item.spu_custom_areas || {},
        { boundingRect: item.customSpu?.customizedImages[theFirstCustomizedArea(item)]?.customized_areas.boundingRect }
      ),
      customizedImage: item.image + `?x-oss-process=image/resize,w_220/quality,q_90` || "",
      width: 1000,
      height: 1000,
      cssWidth: 50,
      cssHeight: 50,
    },
  )
}


const openAddressModal = (value: OrderDetails) => {
  addressVisible.value = true
  currentOrderInfo.value = value
}

const current = ref(1)
const getOrderList = async (fromData?: any) => {
  orderData.length = 0
  const data = {
    number: fromData?.number || searchForm.number || null,
    express_number: fromData?.express_number || searchForm.express_number || null,
    receiver_phone: fromData?.receiver_phone || searchForm.receiver_phone || null,
    limit: fromData?.limit || searchForm.limit,
    offset: fromData?.offset || searchForm.offset,
    status: fromData?.status || searchForm.status || null,
    type: fromData?.type || searchForm.type || null,
    orderStart: fromData?.orderStart || searchForm.orderStart || null,
    orderEnd: fromData?.orderEnd || searchForm.orderEnd || null,
    deliverStart: fromData?.deliverStart || searchForm.deliverStart || null,
    deliverEnd: fromData?.deliverEnd || searchForm.deliverEnd || null,
    importStart: fromData?.importStart || searchForm.importStart || null,
    importEnd: fromData?.importEnd || searchForm.importEnd || null,
  }
  await fetchOrder(data).then((res: any) => {
    total.value = res.total
    res.order.forEach((orderItem: any) => {
      orderData.push({
        id: orderItem.id,
        number: orderItem.number,
        out_trade_number: orderItem.out_trade_number,
        pay_amount: orderItem.pay_amount || '-',
        receive_address: (orderItem.receiver_province || '') + (orderItem.receiver_city || '') + (orderItem.receiver_district || '') + (orderItem.receiver_street || '') + (orderItem.receive_address || ''),
        receiver: orderItem.receiver,
        receiver_phone: orderItem.receiver_phone,
        express_number: orderItem.express_number || '-',
        remark: orderItem.remark || '-',
        status: orderItem.status || '-',
        items: orderItem.items,
        pay_type: orderItem.pay_type,
        express_company_id: orderItem.express_company_id,
        createdAt: dayjs(orderItem.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        pay_at: orderItem.pay_at ? dayjs(orderItem.pay_at).format("YYYY-MM-DD HH:mm:ss") : '-',
        deliver_at: orderItem.deliver_at ? dayjs(orderItem.deliver_at).format("YYYY-MM-DD HH:mm:ss") : '-',
        express_fee: orderItem.express_fee,
        selectCoupon: orderItem.selectCoupon,
        discount_amount: orderItem.discount_amount,
        refunds: orderItem.refunds,
        deliver: orderItem.deliver,
        user: orderItem.user,
        sale: orderItem.sale,
        adjustPrice: orderItem.adjustPrice,
        is_sale: orderItem.is_sale,
        is_design_order: orderItem.is_design_order,
        is_external: orderItem.is_external,
      })
    })
  }).catch(() => {
    message.error(t('orderManagement.OrderManagement.queryOrderListFailed'))
  })
}
const total = ref(0)
// 表格数据
const orderData = reactive<Array<OrderDetails>>([])
const convertAttrs = (attrs: any[]) => {
  const arr = [] as any
  attrs.forEach((a) => {
    const data = {
      name: '',
      value: ''
    }
    data.name = a.attribute.name
    data.value = a.object_value ? a.object_value.name : a.value
    arr.push(data)
  })
  arr.sort(sortBy('name', false))
  return arr
}
const orderSearchValue = computed(() => [
  {
    label: t('orderManagement.OrderManagement.orderNumber'),
    value: 'number',
  }, {
    label: t('orderManagement.OrderManagement.receiverNumber'),
    value: 'receiver_phone',
  }, {
    label: t('orderManagement.OrderManagement.expressNumber'),
    value: 'express_number',
  }
])

const typeList = computed(() => [
  {
    label: t('orderManagement.OrderManagement.all'),
    value: '',
  }, {
    label: t('orderManagement.OrderManagement.importedOrder'),
    value: '1',
  }, {
    label: t('orderManagement.OrderManagement.internalOrder'),
    value: '0',
  }
])
const statusType = ref()
// const statusType = ref([
//   {
//     label: '全部',
//     value: '',
//   },
//   {
//     label: '待付款',
//     value: 1,
//   }, {
//     label: '待生产',
//     value: 2,
//   },
//   {
//     label: '生产中',
//     value: 3,
//   },
//   {
//     label: '待发货',
//     value: 4,
//   },
//   {
//     label: '已发货',
//     value: 5,
//   }, {
//     label: '已完成',
//     value: 6,
//   }, {
//     label: '退款中',
//     value: 7,
//   }, {
//     label: '已取消',
//     value: 8,
//   }, {
//     label: '售后中',
//     value: 9,
//   }
// ])
// 下单时间
const orderTime = ref('')
// 发货时间
const deliverTime = ref('')
// 导入时间
const importTime = ref('')
const timeType = computed(() => [
  {
    label: t('orderManagement.OrderManagement.all'),
    value: '',
  }, {
    label: t('orderManagement.OrderManagement.today'),
    value: '1',
  }, {
    label: t('orderManagement.OrderManagement.yesterday'),
    value: '2',
  }, {
    label: t('orderManagement.OrderManagement.thisWeek'),
    value: '3',
  }, {
    label: t('orderManagement.OrderManagement.thisMonth'),
    value: '4',
  }
])
const remarkValue = ref('')
const remarkVisible = ref(false)
const value1 = ref()
const value2 = ref()
const value3 = ref()
const orderSearch = ref<string>('number')
const inputValue = ref('')

// 搜索项
const flag = ref(false)
const searchForm = reactive<SearchForm>({
  number: '',
  receiver_phone: '',
  express_number: '',
  type: '',
  status: '',
  orderStart: '', // 下单开始时间
  orderEnd: '',
  deliverStart: '', // 发货开始时间
  deliverEnd: '',
  importStart: '', // 导入开始时间
  importEnd: '',
  limit: 10,
  offset: 0
})
const goToDetail = (item: OrderDetails) => {
  const data = {
    ...searchForm,
    orderSearch: orderSearch.value,
    inputValue: inputValue.value,
    orderTime: orderTime.value,
    deliverTime: deliverTime.value,
    importTime: importTime.value,
    value1: value1.value,
    value2: value2.value,
    value3: value3.value,
    current: current.value
  }
  sessionStorage.setItem('searchForm', JSON.stringify(data))
  router.push(`/console/orders/order_management/${item.id}`)
}
watch(
  inputValue, (inputValue) => {
    switch (orderSearch.value) {
      case 'number':
        searchForm.number = inputValue.replace(/\s+/g, "")
        searchForm.receiver_phone = ''
        searchForm.express_number = ''
        break
      case 'receiver_phone':
        searchForm.number = ''
        searchForm.receiver_phone = inputValue.replace(/\s+/g, "")
        searchForm.express_number = ''
        break
      case 'express_number':
        searchForm.number = ''
        searchForm.receiver_phone = ''
        searchForm.express_number = inputValue.replace(/\s+/g, "")
        break
    }
  },
  { deep: true }
)
watch(
  orderTime, (orderTime) => {
    getSearchDate(orderTime, 'orderTime')
  },
  { deep: true }
)
watch(
  deliverTime, (deliverTime) => {
    getSearchDate(deliverTime, 'deliverTime')
  },
  { deep: true }
)
watch(
  importTime, (importTime) => {
    getSearchDate(importTime, 'importTime')
  },
  { deep: true }
)

// 转化时间
const getSearchDate = (time: any, key: string) => {
  switch (time) {
    case '':
      key == 'orderTime' ? searchForm.orderStart = '' : key == 'deliverTime' ? searchForm.deliverStart = '' : key == 'importTime' ? searchForm.importStart = '' : ''
      key == 'orderTime' ? searchForm.orderEnd = '' : key == 'deliverTime' ? searchForm.deliverEnd = '' : key == 'importTime' ? searchForm.importEnd = '' : ''
      break
    case '1':
      {
        const dateStart = dayjs().format('YYYY-MM-DD')
        const dateEnd = dayjs().add(1, 'day').format('YYYY-MM-DD')
        key == 'orderTime' ? searchForm.orderStart = dateStart : key == 'deliverTime' ? searchForm.deliverStart = dateStart : key == 'importTime' ? searchForm.importStart = dateStart : ''
        key == 'orderTime' ? searchForm.orderEnd = dateEnd : key == 'deliverTime' ? searchForm.deliverEnd = dateEnd : key == 'importTime' ? searchForm.importEnd = dateEnd : ''
      }
      break
    case '2':
      {
        const dateStart1 = dayjs().add(-1, 'day').format('YYYY-MM-DD')
        const dateEnd1 = dayjs().format('YYYY-MM-DD')
        key == 'orderTime' ? searchForm.orderStart = dateStart1 : key == 'deliverTime' ? searchForm.deliverStart = dateStart1 : key == 'importTime' ? searchForm.importStart = dateStart1 : ''
        key == 'orderTime' ? searchForm.orderEnd = dateEnd1 : key == 'deliverTime' ? searchForm.deliverEnd = dateEnd1 : key == 'importTime' ? searchForm.importEnd = dateEnd1 : ''
      }
      break
    case '3':
      {
        const dateStart2 = dayjs().startOf('week').add(1, 'day').format('YYYY-MM-DD')
        const dateEnd2 = dayjs().endOf('week').add(1, 'day').format('YYYY-MM-DD')
        key == 'orderTime' ? searchForm.orderStart = dateStart2 : key == 'deliverTime' ? searchForm.deliverStart = dateStart2 : key == 'importTime' ? searchForm.importStart = dateStart2 : ''
        key == 'orderTime' ? searchForm.orderEnd = dateEnd2 : key == 'deliverTime' ? searchForm.deliverEnd = dateEnd2 : key == 'importTime' ? searchForm.importEnd = dateEnd2 : ''
      }
      break
    case '4':
      {
        const dateStart3 = dayjs().startOf('month').format('YYYY-MM-DD')
        const dateEnd3 = dayjs().endOf('month').format('YYYY-MM-DD')
        key == 'orderTime' ? searchForm.orderStart = dateStart3 : key == 'deliverTime' ? searchForm.deliverStart = dateStart3 : key == 'importTime' ? searchForm.importStart = dateStart3 : ''
        key == 'orderTime' ? searchForm.orderEnd = dateEnd3 : key == 'deliverTime' ? searchForm.deliverEnd = dateEnd3 : key == 'importTime' ? searchForm.importEnd = dateEnd3 : ''
      }
      break
  }
}

const closeRemarkVisible = async () => {
  remarkVisible.value = false
}
const submitLoading = ref<boolean>(false)
// 搜索按钮
const submit = async () => {
  submitLoading.value = true
  searchForm.offset = 0
  current.value = 1
  getOrderList()
  submitLoading.value = false
}
// 重置按钮
const clearValue = (clearAll: boolean) => {
  inputValue.value = ''
  searchForm.type = ''
  searchForm.status = ''
  orderTime.value = ''
  deliverTime.value = ''
  importTime.value = ''
  value1.value = ''
  value2.value = ''
  value3.value = ''
  searchForm.number = ''
  searchForm.express_number = ''
  searchForm.receiver_phone = ''
  searchForm.orderStart = ''
  searchForm.orderEnd = ''
  searchForm.deliverStart = ''
  searchForm.deliverEnd = ''
  searchForm.importStart = ''
  searchForm.importEnd = ''
  searchForm.offset = 0
  searchForm.limit = 10
  current.value = 1
  clearAll ? getOrderList() : ''
}
const radioChangeTime = (time: string) => {
  switch (time) {
    case 'orderTime':
      value1.value = ''
      if (!orderTime.value) {
        searchForm.orderStart = ''
        searchForm.orderEnd = ''
      }
      break
    case 'deliverTime':
      value2.value = ''
      if (!deliverTime.value) {
        searchForm.deliverStart = ''
        searchForm.deliverEnd = ''
      }
      break
    case 'importTime':
      value3.value = ''
      if (!importTime.value) {
        searchForm.importStart = ''
        searchForm.importEnd = ''
      }
      break
  }
}
// 日期选择器
const onChangeDate = (value: [Dayjs, Dayjs], dateString: [string, string]) => {
  switch (value) {
    case null:
      orderTime.value = ''
      searchForm.orderStart = ''
      searchForm.orderEnd = ''
      break
    default:
      orderTime.value = ''
      searchForm.orderStart = dateString[0]
      searchForm.orderEnd = dateString[1]
  }
}
// 日期选择器
const onChangeDateDeliver = (value: [Dayjs, Dayjs], dateString: [string, string]) => {
  switch (value) {
    case null:
      deliverTime.value = ''
      searchForm.deliverStart = ''
      searchForm.deliverEnd = ''
      break
    default:
      deliverTime.value = ''
      searchForm.deliverStart = dateString[0]
      searchForm.deliverEnd = dateString[1]
  }
}
// 日期选择器
const onChangeDateImport = (value: [Dayjs, Dayjs], dateString: [string, string]) => {
  switch (value) {
    case null:
      importTime.value = ''
      searchForm.importStart = ''
      searchForm.importEnd = ''
      break
    default:
      importTime.value = ''
      searchForm.importStart = dateString[0]
      searchForm.importEnd = dateString[1]
  }
}
// 分页
const changePage = (currentPage: number, pageSize: number) => {
  current.value = currentPage
  searchForm.limit = pageSize
  searchForm.offset = (currentPage - 1) * pageSize
  getOrderList()
}
const visible = ref(false)
const afterVisible = ref(false)
const afterType = ref('add')
const recordId = ref<number>(0)
const status = ref<number>()
const title = ref('')
const content = ref('')
const afterSaleContent = ref()
const afterSaleClick = (record: any) => {
  afterVisible.value = true
  afterSaleContent.value = record
  afterType.value = record.status == 9 || record.refunds.length > 0 ? 'edit' : 'add'
}
// 取消
const cancelPayment = (record: any) => {
  visible.value = true
  recordId.value = record.id
  status.value = record.status
  title.value = t('orderManagement.OrderManagement.cancelPayment')
  content.value = t('orderManagement.OrderManagement.confirmCancelPayment')
}

const orderPayAmount = ref<number>(0)
const is_design_order = ref<boolean>(false)
// 申请退款
const refundApply = (record: any) => {
  remarkVisible.value = true
  recordId.value = record.id
  status.value = record.status
  orderPayAmount.value = record.pay_amount
  is_design_order.value = record.is_design_order
}
const cancelRefund = async (record: any) => {
  await updateOrder(record.id, { status: 2, remark: '' }).then(res => {
    message.success(t('orderManagement.OrderManagement.cancelRefundSuccessful'))
    getOrderList()
  }).catch(() => {
    message.error(t('orderManagement.OrderManagement.cancelRefundFailed'))
  })
}

const onCancelOk = async () => {
  if (orderPayAmount.value == 0 && is_design_order.value) {
    await updateOrder(recordId.value, { status: 8, remark: remarkValue.value }).then(res => {
      message.success(`${title.value}${t('orderManagement.OrderManagement.success')}`)
    }).catch(() => {
      message.error(`${title.value}${t('orderManagement.OrderManagement.fail')}`)
    })
  } else if (orderPayAmount.value == 0 && status.value == 2) {
    await refundOrder(recordId.value).then(res => {
      message.success(`${title.value}${t('orderManagement.OrderManagement.success')}`)
    }).catch(() => {
      message.error(`${title.value}${t('orderManagement.OrderManagement.fail')}`)
    })
  } else {
    if (status.value == 1) {
      await cancelOrder(recordId.value).then(res => {
        message.success(`${title.value}${t('orderManagement.OrderManagement.success')}`)
      }).catch(() => {
        message.error(`${title.value}${t('orderManagement.OrderManagement.fail')}`)
      })
    } else {
      const params: any = { status: 7 }
      switch (status.value) {
        case 2:
          params.status = 7
          params.remark = remarkValue.value
          break
        case 5:
          params.status = 6
          break
      }
      await updateOrder(recordId.value, params).then(res => {
        message.success(`${title.value}${t('orderManagement.OrderManagement.success')}`)
      }).catch(() => {
        message.error(`${title.value}${t('orderManagement.OrderManagement.fail')}`)
      })
    }
  }
  visible.value = false
  remarkVisible.value = false
  getOrderList()
}
const payVisible = ref<boolean>(false)
// 支付方式
const payment = ref(0)
const payRecord = ref()
const number = ref<string>('')
const confirmLoading = ref<boolean>(false)
const payClick = async (record: any) => {
  const number = record.adjustPrice ? record.adjustPrice.adjust_number : record.number
  if (record.pay_type === 0) {
    queryAlipay({ outTradeNo: number })
      .then((res: any) => {
        if (res.code === '10000') {
          payVisible.value = true
          payRecord.value = record
          return
        }
        getOrderList()
        message.success(t('orderManagement.OrderManagement.orderHasBeenPaid'))
      })
      .catch(() => {
        payVisible.value = true
        payRecord.value = record
      })
  } else if (record.pay_type === 1 || record.pay_type === 2) {
    const wx_number = record.pay_type == 1 ? `${number}-PC` : `${number}-APP`
    await queryWxpay({ number: wx_number })
      .then((res: any) => {
        if (res.result.result_code == 'SUCCESS' && res.result.trade_state == 'SUCCESS') {
          getOrderList()
          message.success(t('orderManagement.OrderManagement.orderHasBeenPaid'))
        } else {
          payVisible.value = true
          payRecord.value = record
        }
      })
      .catch(() => {
        payVisible.value = true
        payRecord.value = record
      })
  }
}
const onCancelPayOk = async () => {
  switch (payment.value) {
    case 0:
      await alipayClick(payRecord.value)
      await getOrderList()
      break
    case 1:
      await wxpayClick(payRecord.value)
      break
  }
}

// 临时解决方案 接口返回的customizedImages顺序不一致 order排序以后 sql太长不生效 加入 separate: true会丢失custom spu id 导致数据为空 
const theFirstCustomizedArea = (record: any) => {
  if (record.customSpu && record.customSpu.customizedImages && record.customSpu.customizedImages.length)
    return record.customSpu.customizedImages.reduce((minIdx: number, curr: any, idx: number, array: any[]) => {
      return curr.custom_area_id < array[minIdx].custom_area_id ? idx : minIdx
    }, 0)
  else return 0
}
const onCancelWxpayOk = async () => {
  confirmLoading.value = true
  const data = { number: `${number.value}-PC` }
  const res: any = await queryWxpay(data)
  res.result.trade_state == 'SUCCESS' ? message.success(t('orderManagement.OrderManagement.paymentSuccessful')) : message.error(t('orderManagement.OrderManagement.paymentFailed'))
  wxVisible.value = false
  payVisible.value = false
  confirmLoading.value = false
  await getOrderList()
}
// 微信付款
const wxpayClick = async (record: any) => {
  const spuName = record.items.length > 1 ? record.items[0].spu_name + `...${t('orderManagement.OrderManagement.soso')}` : record.items[0].spu_name
  const data = {
    number: record.adjustPrice ? record.adjustPrice.adjust_number : record.number,
    totalAmount: record.adjustPrice ? record.adjustPrice.pay_amount : record.pay_amount,
    subject: spuName,
    productCode: 'FAST_INSTANT_TRADE_PAY',
  }
  await wxpay(data).then(async (res: any) => {
    code_img.value = await QRCode.toDataURL(res.url)
    number.value = res.number
    wxVisible.value = true
  }).catch(() => {
    message.error(t('orderManagement.OrderManagement.payFailed'))
  })
}
// 支付宝付款
const alipayClick = async (record: any) => {
  const spuName = record.items.length > 1 ? record.items[0].spu_name + `...${t('orderManagement.OrderManagement.soso')}` : record.items[0].spu_name
  const data = {
    number: record.adjustPrice ? record.adjustPrice.adjust_number : record.number,
    totalAmount: record.adjustPrice ? record.adjustPrice.pay_amount : record.pay_amount,
    subject: spuName,
    productCode: 'FAST_INSTANT_TRADE_PAY',
  }
  await alipay(data).then((res: any) => {
    window.location.href = res.url
  }).catch(() => {
    message.error(t('orderManagement.OrderManagement.payFailed'))
  })
}

const colorOfItem = (item: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}
const expressVisible = ref<boolean>(false)
const rowData = ref<any[]>([])
const receive_address = ref<string>('')
// 快递信息
const expressClick = async (record: any) => {
  if (record.status < 5 || !record.express_company_id || record.express_number == '-') {
    return
  }
  rowData.value = []
  receive_address.value = record.receive_address
  const data = {
    express_number: record.express_number,
    receiver_phone: record.receiver_phone,
    express_company_id: record.express_company_id
  }
  await queryExpress(data).then((res: any) => {
    rowData.value = res.logistics
    if (rowData.value.length > 0) {
      rowData.value[0].status = 'finish'
      expressVisible.value = true
    } else {
      message.warning(t('orderManagement.OrderManagement.queryResultIsEmpty'))
    }

  }).catch(err => {
    message.error(err.message)
  })
}
const visibleChange = (visible: any) => {
  expressVisible.value = visible
}
const afterChange = (visible: any) => {
  afterVisible.value = visible
  getOrderList()
}
const isComment = (comment: any) => {
  const data = comment.findIndex((c: any) => { return c.is_comment == false })
  return data != -1
}
const goToComment = (record: any) => {
  router.push(`/console/orders/order_management/comment/${record.id}`)
}
</script>
<style scoped lang="less">
.order-content {
  overflow: auto;
  padding: 20px;
  // height: 100%;
  font-size: 14px;
  color: #111;

  .order-card {
    width: 100%;
    background-color: #ffffff;


    .order-header {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .order-search-box {
        width: 450px;

        .order-search-select {
          height: 32px;
          width: 130px;
        }

        .order-search-input {
          height: 32px;
          width: 200px;
        }
      }

      :deep(.ant-select-selector) {
        align-items: center;
        text-align: center;
        background: #f6f6f6;
      }

      :deep(.ant-btn) {
        height: 40px;
        line-height: 40px;
      }

      .btn-box {
        display: flex;
        justify-content: flex-end;
      }

      .search-button {
        width: 100%;
        padding: 0 10px;
        margin-right: 10px;

        .icon-size {
          font-size: 16px;
        }
      }

      .order-button {
        width: 100%;
        padding: 0 10px;
        background: #fff;
        margin-right: 10px;
        color: #111;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }

    }

    .order-search {
      .ant-form .ant-form-item {
        // height: 40px;
        // line-height: 40px;
        margin: 25px 115px 0 0;
      }

      .ant-select {
        width: 126px;
        // height: 40px;

        :deep(.ant-select-selector) {
          width: 126px;
          // height: 40px;
          // line-height: 40px;
          align-items: center;
        }
      }

      .ant-picker {
        width: 300px;
        // height: 40px;
        margin-left: 10px;
        height: 32px;
      }
    }
  }



  .order-middle {
    height: 30px;
    line-height: 30px;
    margin: 10px 5px;

    .totle-title {
      font-family: 'Microsoft YaHei Bold';
      font-weight: bold;
      margin: 0 5px;
    }
  }

  .order-footer {
    .scrollTable {
      flex: 1;
      overflow: hidden;
      height: calc(100vh - 530px);
    }

    .hidden {
      width: 48px;
      height: 48px;
      position: absolute;
      visibility: hidden;
      display: block;
    }

    .viewer {
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      @-moz-document url-prefix() {
        :deep(.fabric-div) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.canvas-container) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.lower-canvas) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.upper-canvas) {
          width: 48px !important;
          height: 48px !important;
        }
      }
    }

    .flex-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .item-flex {
        display: flex;
        flex-direction: column;
        margin: 0 10px;
        text-wrap: wrap;
        text-align: start;
        white-space: pre-wrap;
        width: 350px;

        .item-attr {
          font-size: 12px;
        }

        .attr_color {
          color: #999;
          margin-right: 5px;
        }
      }

      .item-quality {
        flex: 1;
        text-align: right;
      }
    }

    .receive-address {
      text-align: start;
      text-wrap: wrap;

      .receiver-margin {
        margin-left: 10px;
      }

      .receive-address-deliver {
        color: #009ad6;
        cursor: pointer;
      }
    }

    .express-self-pickup {
      text-align: start;
      text-wrap: wrap;
      word-break: break-all;
    }

    :deep(.ant-table) {
      border: 0;
      line-height: 20px;
    }

    :deep(.ant-table-tbody) {
      font-size: 12px;
    }

    .operation-icon {
      font-size: 20px;
      cursor: pointer;
      margin: 0 10px;
      color: #999
    }

    .operation-icon:hover {
      color: #111;
    }

    .page-box {
      margin-top: 10px;
      float: right;
    }
  }

}

.refund-application-content {
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: 30px;
  font-size: 16px;
}

:deep(.ant-popover-inner-content) {
  padding: 0;
}

.total-pee {
  font-size: 14px;
  font-weight: bold;
  color: #111111;
}

.ant-col {
  height: 32px;
}

.divider-line {
  margin: 7px 0 10px 0;
}

.price-color {
  font-size: 20px;
  font-weight: bold;
  color: #DE4A09;
}

.text-align {
  text-align: end;
}

.price-size {
  font-weight: bold;
}

.flex {
  display: flex;
  justify-content: center;
}
</style>
